
import React from "react";
import FeedbackToolView from "../components/Feedback";
import { SalesPageToolSet } from "./SalesPageToolSet";


const FeedbackContainer = (props) => {

    const [tool,setTool] = React.useState({});

    

    React.useEffect(()=>{
        if(props.match.params.id){
            let filteredTool =  SalesPageToolSet.find(value=>value.id === parseInt(props.match.params.id))
            setTool(filteredTool)
        }

    },[props.match.params.id])


    return (
        <>
            <FeedbackToolView tool = {tool} />
        </>
    );
};

export default FeedbackContainer;

